/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import { FormulaBin } from './types';

/** set max_is_inclusive to true unless there is another bin whose min is the same as this bin's max */
export function setMaxIsInclusive(bins: FormulaBin[]): FormulaBin[] {
  return bins.map((bin, index) => ({
    ...bin,
    max_is_inclusive:
      bin.max == null || !bins.some((otherBin, otherIndex) => otherIndex !== index && otherBin.min === bin.max),
  }));
}

export const formatScoreNumber = (num: number): string => {
  return parseFloat(num.toFixed(2)).toString();
};
